import { Tag } from '@dev-spendesk/grapes';
import React from 'react';

import { useTranslation } from 'common/hooks/useTranslation';

import { useGetErrorTranslation } from './useGetErrorTranslation';

type PaymentErrorTagProps = {
  error: string;
  errorDetails?: unknown;
};

export const PaymentErrorTag = ({
  error,
  errorDetails,
}: PaymentErrorTagProps) => {
  const { t } = useTranslation('global');

  const getErrorTranslation = useGetErrorTranslation();
  const translatedError = getErrorTranslation(error);

  if (translatedError) {
    return <Tag variant="warning">{translatedError}</Tag>;
  }

  const errorDetailsMessage =
    Array.isArray(errorDetails) && errorDetails?.[0]?.message;
  if (errorDetailsMessage) {
    return <Tag variant="warning">{errorDetailsMessage}</Tag>;
  }

  return (
    <Tag variant="alert">
      {t('wiretransfer.confirmation.errorModal.unknownError')}
    </Tag>
  );
};
